import React, { useState } from 'react';
// import Logo from '@/Shared/Logo';
import { Col, Row, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faLongArrowAltRight} from '@fortawesome/free-solid-svg-icons'
import { APP_NAME } from '@/constants/Site';
import PrimaryMenu from '@/Shared/Layouts/Menus/PrimaryMenu';
import { parrafos } from '@/Shared/FuncComp';
import MainSocialMenu from '@/Shared/Layouts/Menus/MainSocialMenu';
import ContactoMenu from '@/Shared/Layouts/Menus/ContactoMenu';
import Link from '@/Shared/Link';

export default () => {
    return <Container>
        <Row className="justify-content-center">
            <Col md className="d-flex flex-column mt-4">
                <h3>{APP_NAME}</h3>
                {parrafos("Es una empresa peruana con amplia experiencia en el mercado nacional e internacional. Comercializamos equipos para control de procesos y automatización para los sectores de manufactura, pesquería, agroindustria, minero metalúrgico, petróleo, gas entre otros.")}
                <div className="d-flex col align-items-center">
                    <Link link="about" className="link text-nowrap">Ver más 
                        <FontAwesomeIcon icon={faLongArrowAltRight} className="ml-3" />
                    </Link>
                </div>
            </Col>
            <Col xs="auto" className="mt-4">
                <h6 className="text-uppercase">MENÚS</h6>
                <PrimaryMenu className="flex-column" append={[{route: 'dashboard', name: 'Intranet'}]} />
            </Col>
            <Col xs="auto" className="mt-4">
                <h6 className="text-uppercase">SÍGUENOS</h6>
                <MainSocialMenu withNames className="flex-column" />
            </Col>
            <Col xs="auto" className="mt-4">
                <h6 className="text-uppercase">CONTACTO</h6>
                <ContactoMenu className="flex-column" />
                <div className="w-100" dangerouslySetInnerHTML={{__html: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3901.4631553046283!2d-77.0296594376455!3d-12.080412813918269!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c88be274384d%3A0x29de95498fb30db5!2sIQ%20SAC!5e0!3m2!1ses-419!2spe!4v1609077189573!5m2!1ses-419!2spe" width="300" height="200" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>'}} />
            </Col>
        </Row>
    </Container>
}
